<template>
  <div class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div><i class="icon-people mr-1"></i>Sales Agents</div>
        <router-link to="/settings/salesAgent/new" :event="permission.capabilities.Create ? 'click' : ''">
          <b-button variant="primary" :disabled="!permission.capabilities.Create">
            <i class="fa fa-plus"></i>&nbsp;New
          </b-button>
        </router-link>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <v-client-table
          :columns="columns"
          :data="data"
          :options="options"
          :theme="theme"
          id="dataTable"
        >
          <a
            slot="name"
            slot-scope="props"
            title="View"
          >{{props.row.name}}</a>
          <a
            slot="users"
            slot-scope="props"
            title="View"
            :href="'/settings/salesAgent/users/' + props.row.salesAgent_id"
          >view Users</a>
          <div
            slot="action"
            slot-scope="props"
          >
            <div class="input-group input-group-sm action">
              <b-dropdown
                variant="link"
                size="lg"
                no-caret
              >
                <template slot="button-content">
                  <i
                    class="fa fa-cog"
                    aria-hidden="true"
                  ></i>
                </template>
                <b-dropdown-item
                  @click="openEditPage(props.row.id)" :disabled="!permission.capabilities.Edit"
                ><i class="fa fa-edit"></i>&nbsp;Edit</b-dropdown-item>
                <b-dropdown-item
                  @click="openDeleteModal(props.row.id)" :disabled="!permission.capabilities.Delete"
                ><span style="color: #20a8d8;"><i class="fa fa-trash"></i>&nbsp;Delete</span></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

        </v-client-table>
      </b-card-body>
    </b-card>
    <b-modal
      title="Delete a sales agent"
      class="modal-danger"
      v-model="deleteModalOpen"
      @ok="deleteSalesAgent()"
      ok-variant="danger"
    >
      Delete the sales agent {{salesAgent_name}} ?
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import { router } from "../../router/index";

const Spinner = () => import("../shared/Spinner");

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options);

//todo: create a function getUserRole() to access the current user role and group (request server ?)
const userRole = "Not a Customer";
const userGroup = "foo";

Vue.use(ClientTable);

//Column's customization depending on the user's role
let columns = [
  "action",
  "salesAgent_name",
  "email",
  "website",
  "users",
  "score"
];

let headings = {
  action: "",
  salesAgent_name: "Name",
  email: "Email",
  website: "Website",
  users: "Users List",
  score: "Score"
};
let sortable = ["salesAgent_name", "email", "website", "score", "id"];
let filterable = ["salesAgent_name", "email", "website", "score", "id"];

//Export component
export default {
  salesAgent_name: "salesAgents",
  components: {
    ClientTable,
    Spinner,
    Event
  },
  data: function() {
    let selectedCompany;
    if (window.location.href.includes("/settings/company/users/")) {
      selectedCompany = this.$route.params.company;
    } else {
      selectedCompany = null;
    }
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || 'Asia/Bangkok';
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      isLoading: true,
      columns: columns,
      data: [],
      options: {
        headings: headings,
        sortable: sortable,
        filterable: filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",

      //Use for delete modal
      deleteModalOpen: false,
      id: null,
      salesAgent_id: null,
      salesAgent_name: null
    };
  },
  watch: {
    "this.$parent.$parent.permissionName": function() {
      this.permissionName = this.$parent.$parent.permissionName;
    }
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    openDeleteModal: function(id) {
      this.deleteModalOpen = true;
      this.id = id;
      this.name = this.data[id].name;
      this.salesAgent_id = this.data[id].salesAgent_id;
    },
    openEditPage: function(id) {
      this.id = id;
      this.salesAgent_id = this.data[id].salesAgent_id;
      this.salesAgent_name = this.data[id].salesAgent_name;
      localStorage.setItem("page_salesAgent_id", this.salesAgent_id);
      localStorage.setItem("page_salesAgent_name", this.salesAgent_name);
      router.push("/settings/salesAgent/edit/");
    },
    deleteSalesAgent: function(id) {
      let that = this;
      this.deleteModalOpen = false;
      this.isLoading = true;
      this.data.splice(this.id, 1);
      //Update ids
      for (let i = this.id; i < this.data.length; i++) {
        this.data[i].id--;
      }
      let salesAgent_id = this.salesAgent_id;
      let method = "DELETE";
      let pathTemplate = "/salesAgents/" + salesAgent_id;
      let additionalParams = {};
      let pathParams = {};

      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          that.isLoading = false;
          that.showSuccessMsg();
        })
        .catch(function(error) {
          that.isLoading = false;
          that.showErrorMsg({ message: error.message });
        });
    },
    loadData: function() {
      var method = "GET";
      var pathTemplate = "/users";
      var additionalParams = {};
      var pathParams = {};
      var userDatas = [];
      var that = this;
      let params = {
        fields: [
          "id",
          "company_id",
          "username",
          "firstname",
          "lastname",
          "createdAt",
          "apiUser",
          "password",
          "email",
          "role_id"
        ],
        filter: [
          {
            fieldname: "isDeleted",
            comparisonOperator: "=",
            value: false
          },
          {
            fieldname: "group_id",
            comparisonOperator: "=",
            value: 2
          }
        ]
      };
      if (that.company_id) {
        params.filter.push({
          fieldname: "company_id",
          comparisonOperator: "=",
          value: that.company_id
        });
      }
      additionalParams = {
        queryParams: {
          params: JSON.stringify(params)
        }
      };
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          if (result.data.status) {
            let data = result["data"]["data"].map((elem, index) => {
              elem.salesAgent_id = elem.id;
              elem.id = index;
              elem.salesAgent_name = elem.salesAgentName;
              elem.email = elem.email;
              elem.website = elem.website;
              elem.score = elem.score;
              return elem;
            });
            that.data = [...data];
          } else {
            that.showErrorMsg({ message: result.data.message });
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    }
  },
  mounted: function() {
    let that=this;
    that.getPermission();
    if(!that.permission.capabilities.View){
      that.showPage403 = true;
      return;
    }
    this.loadData();
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The sales agent has been deleted"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Hey you",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Wow, man",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ""
    }
  }
};
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style scoped>
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}

.card-body {
  padding: 0 !important;
}
</style>

<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .action {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-secondary {
  background-color: none;
}

.modal-dialog {
  color: black;
}

.container-fluid {
  margin: 0 !important;
  padding: 0 !important;
}

.breadcrumb {
  margin-bottom: 0;
  border-bottom: 0;
}
#dataTable {
  margin: 18px auto;
}
</style>
